import { useCallback } from 'react';

// ----------------------------------------------------------------------

const REF_CODE_KEY = 'ref_code';

export function useRefCode() {
  const setRefCode = useCallback((code: string) => {
    sessionStorage.setItem(REF_CODE_KEY, code);
  }, []);

  const getRefCode = useCallback(() => sessionStorage.getItem(REF_CODE_KEY) ?? '', []);

  const clearRefKey = useCallback(() => {
    sessionStorage.removeItem(REF_CODE_KEY);
  }, []);

  return {
    // setters
    setRefCode,

    // getters
    getRefCode,

    clearRefKey,
  };
}
